// src/data/fallbackProjects.js
// Curated local fallback projects dataset when backend server is unavailable

const FALLBACK_PROJECTS = [
  // Residential
  {
    id: 101,
    name: "City One Vezdaa",
    category: "Residential",
    services: "Design for Electrical power distribution, Plumbing services & fire fighting services.",
    description: "Project Approximate Area 4.0 Lakh Sq.Ft. Project consists of 2 mixed-use towers with 30 floors.",
    image: "/images/City_One_Vezdaa.jpg",
    location: "Ravet"
  },
  {
    id: 102,
    name: "Kohinoor Westview Reserve",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 3.21 acre. Project consists of 6 Towers with 22 floors and 700 residential units.",
    image: "/images/Kohinoor_Westview_Reserve.jpg",
    location: "Wakad"
  },
  {
    id: 103,
    name: "Kohinoor Courtyard One",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 5.21 acre. Project consists of 3 Towers with 21 floors and 388 residential units.",
    image: "/images/Kohinoor_Courtyard_One.jpg",
    location: "Wakad"
  },
  {
    id: 104,
    name: "Kohinoor Sapphire",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 4.01 acre. Project consists of 9 Towers with 13 floors and 450 residential units.",
    image: "/images/Kohinoor_Saphhire.jpg",
    location: "Tathwade"
  },
  {
    id: 105,
    name: "K Shire",
    category: "Residential",
    services: "Design for Electrical power distribution, Plumbing services & fire fighting services.",
    description: "Project Approximate Area 11 acre. Project consists of 12 residential towers with 1400 units.",
    image: "/images/K_Shire.jpg",
    location: "Punawale"
  },
  {
    id: 106,
    name: "K City",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 5 acre. Project consists of 5 Towers with 13 floors and 800 residential units.",
    image: "/images/K_City.jpg",
    location: "Keshavnagar"
  },
  {
    id: 107,
    name: "K Town",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 10 acre. Project consists of 8 Towers with 950 residential units.",
    image: "/images/K_Town.jpg",
    location: "Kiwale"
  },
  {
    id: 108,
    name: "K Ville",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 7.5 acre. Project consists of 8 buildings (22 storeys) with 920 residential units.",
    image: "/images/K_Ville.jpg",
    location: "Kiwale"
  },
  {
    id: 109,
    name: "Unique Legacy Regal",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 2 acre. Project consists of 5 Towers with 250 residential units.",
    image: "/images/Unique_Legacy_Regal.jpg",
    location: "Mundhwa"
  },
  {
    id: 110,
    name: "Unique Youtopia",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 5.5 acre. Project consists of 10 Towers with 1500 residential units.",
    image: "/images/Unique_Youtopia.jpg",
    location: "Kharadi"
  },
  {
    id: 111,
    name: "Royale",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 85,896 Sq. Ft. Project consists of 14 Floors with 300 residential units.",
    image: "/images/Royale.jpg",
    location: "Mundhwa"
  },
  {
    id: 112,
    name: "Unique Legacy Majestic",
    category: "Residential",
    services: "Design for Electrical power distribution, LV System & Plumbing services.",
    description: "Project Approximate Area 1 acre. Project consists of 2 buildings with 200 residential units.",
    image: "/images/Unique_Legacy_Majestic.jpg",
    location: "Pune"
  },

  // Commercial
  {
    id: 201,
    name: "Kohinoor World Tower",
    category: "Commercial",
    services: "Design for HVAC, Electrical power distribution, Fire Fighting & Plumbing services.",
    description: "Iconic commercial skyscraper complex with state-of-the-art MEP infrastructure.",
    image: "/images/Kohinoor_World_Tower.jpg",
    location: "Pimpri"
  },
  {
    id: 202,
    name: "Kohinoor Business Tower",
    category: "Commercial",
    services: "Design for Electrical, HVAC & Fire Fighting systems.",
    description: "Premium corporate workspace tower with modern energy-efficient HVAC and smart automation.",
    image: "/images/Kohinoor_Business_Tower.jpg",
    location: "Baner"
  },
  {
    id: 203,
    name: "Commercial Building",
    category: "Commercial",
    services: "Integrated MEP solutions for modern commercial complex.",
    description: "Comprehensive electrical distribution, HVAC, and life safety systems.",
    image: "/images/Commercial_Building.jpg",
    location: "Pune"
  },
  {
    id: 204,
    name: "Western Tower, Mixed Use Project",
    category: "Commercial",
    services: "MEP consultancy for high-rise commercial space.",
    description: "Mixed-use retail and office tower with centralized utility management.",
    image: "/images/Western_Tower,_Mixed_Use_Project.jpg",
    location: "Pune"
  },

  // Hospitality
  {
    id: 301,
    name: "Gaachee Resort",
    category: "Hospitality",
    services: "Luxury resort MEP design & energy efficient systems.",
    description: "High-end resort featuring eco-friendly HVAC, pool filtration, and ambient architectural lighting.",
    image: "/images/Gaachee_Resort.jpg",
    location: "Lonavala"
  },
  {
    id: 302,
    name: "Bougainvillea Resort",
    category: "Hospitality",
    services: "Plumbing, electrical & HVAC for resort complex.",
    description: "Serene boutique resort with custom landscape electrical and water treatment solutions.",
    image: "/images/Bougainvillea_Resort.jpg",
    location: "Mulshi"
  },
  {
    id: 303,
    name: "Hotel Bagalkot",
    category: "Hospitality",
    services: "Complete MEP consultancy for hotel project.",
    description: "Full service business hotel with central air conditioning and emergency backup systems.",
    image: "/images/Hotel_Bagalkot.jpg",
    location: "Bagalkot"
  },

  // Industrial
  {
    id: 401,
    name: "AAC Block Factory",
    category: "Industrial",
    services: "High voltage electrical distribution & industrial piping systems.",
    description: "Heavy manufacturing facility engineered with robust power grids and automated process piping.",
    image: "/images/AAC_Block_Factory.jpg",
    location: "Chakan"
  },
  {
    id: 402,
    name: "HY - Tech Fluid Power PVT. LTD.",
    category: "Industrial",
    services: "Industrial piping, fire safety & electrical design.",
    description: "Specialized fluid hydraulics manufacturing plant with advanced fire suppression systems.",
    image: "/images/HY_-_Tech_Fluid_Power_PVT._LTD.jpg",
    location: "Bhosari"
  },
  {
    id: 403,
    name: "Anant Defense System PVT. LTD.",
    category: "Industrial",
    services: "Precision MEP & ventilation infrastructure.",
    description: "High-tech defense component facility with specialized clean room HVAC and safety protocols.",
    image: "/images/Anant_Defense_System_PVT._LTD.jpg",
    location: "Pune"
  },

  // Hospital
  {
    id: 501,
    name: "Vitthal Multispeciality Hospital",
    category: "Hospital",
    services: "Medical gas pipeline, cleanroom HVAC & emergency power backup design.",
    description: "Multi-specialty healthcare facility with uninterrupted power supply and specialized hospital MEP.",
    image: "/images/Vitthal_Multispeciality_Hospital.jpg",
    location: "Pune"
  },
  {
    id: 502,
    name: "Rukmani Test Tube Baby Centre & Childrens Hospital",
    category: "Hospital",
    services: "Specialized healthcare MEP infrastructure & safety systems.",
    description: "Advanced IVF and pediatric hospital equipped with isolated power units and cleanroom air handling.",
    image: "/images/Rukmani_Test_Tube_Baby_Centre_&_Childrens_Hospital.jpg",
    location: "Pune"
  },

  // Automobile
  {
    id: 601,
    name: "Tata Showroom & Workshop",
    category: "Automobile",
    services: "Showroom lighting, power distribution & workshop utility lines.",
    description: "Automobile dealership and service hub with high-capacity pneumatic and electrical piping.",
    image: "/images/Tata_Showroom_&_Workshop.jpg",
    location: "Pune"
  },
  {
    id: 602,
    name: "DSK Toyota Showroom & Workshop",
    category: "Automobile",
    services: "Complete MEP design for automobile dealership & service center.",
    description: "Flagship automotive showroom and multi-bay service center featuring modern MEP systems.",
    image: "/images/DSK_Toyota_Showroom_&_Workshop.jpg",
    location: "Pune"
  }
];

export function getFallbackProjects(category, page = 1, limit = 9, fetchAll = false) {
  let filtered = FALLBACK_PROJECTS;
  if (category) {
    filtered = FALLBACK_PROJECTS.filter(p => p.category.toLowerCase() === category.toLowerCase());
    if (filtered.length === 0) {
      filtered = FALLBACK_PROJECTS;
    }
  }

  if (fetchAll) {
    return filtered;
  }

  const offset = (page - 1) * limit;
  return filtered.slice(offset, offset + limit);
}

export default FALLBACK_PROJECTS;
